import React, { useState, useEffect } from 'react';
import UserService from '../services/UserService';
import FaylService from '../services/FaylService';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  AppBar,
  Box,
  CssBaseline,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Avatar,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  DirectionsCar as TransportIcon,
  Assignment as PutevkaIcon,
  CardMembership as LicenseIcon,
  LocalShipping as IjaraIcon,
  Person as DriverIcon,
  Logout as LogoutIcon,
  AccountCircle as AccountCircleIcon,
} from '@mui/icons-material';
import License from "./License";
import { useLocation } from 'react-router-dom';
import UserProfile from "./UserProfile";
import {ImProfile} from "react-icons/im";
import {Cash, InfoCircle} from "react-bootstrap-icons";
import Kassa from "./Kassa"; // Qo‘shing


const drawerWidth = 210;

const menuItems = [
  { text: 'Transport', icon: <TransportIcon />, path: '/dashboard/transport', component: <License /> },
  { text: 'Putyovka', icon: <PutevkaIcon />, path: '/dashboard/putyovka' , component: <License /> },
  { text: 'Litsenziya', icon: <LicenseIcon />, path: '/dashboard/license' , component: <License /> },
  { text: 'Ijara', icon: <IjaraIcon />, path: '/dashboard/rent' , component: <License /> },
  { text: 'User', icon: <DriverIcon />, path: '/dashboard/user' , component: <License /> },
  { text: 'Profil', icon: <InfoCircle />, path: '/dashboard/profile' , component: <UserProfile /> },
  { text: 'Kassa', icon: <Cash />, path: '/dashboard/kassa' , component: <Kassa /> },
];

const Dashboard = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [userAvatar, setUserAvatar] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const userId = localStorage.getItem('userId');
        if (userId) {
          const response = await UserService.getUserById(userId);
          if (response.success && response.data) {
            const userData = response.data;
            if (userData.avatar) {
              setUserAvatar(FaylService.getAvatarPath(userData.avatar));
            }
          }
        }
      } catch (error) {
        console.error('Error fetching user profile:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, []);
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation(); // route holatini olamiz


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    logout();
  };

  const handleNavigation = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  const drawer = (
    <div style={{backgroundColor: '#f0f0f0', height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Toolbar sx={{display: 'flex', justifyContent: 'center', py: 2}}>
            <img
                src="/logo.png" // public/images/logo.png bo'lishi kerak
                alt="Truck Manager Logo"
                style={{height: 60, marginRight: 8, backgroundColor: 'black'}}
            />
            {/*  <Typography variant="h6" noWrap component="div">*/}
            {/*    Truck Manager*/}
            {/*  </Typography>*/}
            </Toolbar>
            <Divider/>
            <List>
                {menuItems.map((item) => (
                    <ListItem key={item.text} disablePadding>
                        {/*{item.path === '/dashboard/profile' && (*/}
                        {/*    <Divider style={{ width: '100%', height: '1px', backgroundColor: 'black' }} />*/}
                        {/*)}*/}
                        <ListItemButton
                            onClick={() => handleNavigation(item.path)}
                            selected={(location.pathname === '/dashboard' ? '/dashboard/transport' : location.pathname) === item.path}
                            sx={{
                                '&.Mui-selected': {
                                    backgroundColor: '#1976d2', // ko‘k
                                    color: 'white',
                                    borderRadius: '8px',
                                    marginX: '4px',
                                    '& .MuiListItemIcon-root': {
                                        color: 'white',
                                    },
                                },
                                '&:hover': {
                                    backgroundColor: 'rgba(248,249,250,0.78)', // hover - kulrang
                                    borderRadius: '8px',
                                    marginX: '4px',
                                },
                            }}
                        >
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <ListItemText primary={item.text}/>
                        </ListItemButton>
                    </ListItem>

                    // <ListItem key={item.text} disablePadding>
                    //   <ListItemButton onClick={() => handleNavigation(item.path)}>
                    //     <ListItemIcon>{item.icon}</ListItemIcon>
                    //     <ListItemText primary={item.text} />
                    //   </ListItemButton>
                    // </ListItem>
                ))}
            </List>
            <div style={{
                marginTop: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingBottom: '16px'
            }}>
                <Divider style={{width: '100%', height: '1px', backgroundColor: 'black'}}/>
                <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <Tooltip title="Hisob sozlamalari">
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            <Avatar
                                sx={{
                                    width: 80,
                                    height: 80,
                                    bgcolor: 'primary.main',
                                    fontSize: '2rem'
                                }}
                                src={userAvatar}
                                alt={currentUser?.name || 'User'}
                            >
                                {!userAvatar && <AccountCircleIcon fontSize="inherit"/>}
                            </Avatar>
                        </IconButton>
                    </Tooltip>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={() => {
                            handleClose();
                            navigate('/dashboard/profile');
                        }}>
                            <ListItemIcon>
                                <AccountCircleIcon fontSize="small"/>
                            </ListItemIcon>
                            Profil
                        </MenuItem>
                        <Divider/>
                        <MenuItem onClick={handleLogout}>
                            <ListItemIcon>
                                <LogoutIcon fontSize="small"/>
                            </ListItemIcon>
                            Chiqish
                        </MenuItem>
                    </Menu>
                    <Typography variant="h5" sx={{mr: 2, display: {xs: 'none', sm: 'block'}}}>
                        {currentUser?.name || 'Foydalanuvchi'}
                    </Typography>
                </Box>
            </div>

    </div>
);

return (
    <Box sx={{display: 'flex'}}>
        <CssBaseline/>
        <AppBar
            position="fixed"
            sx={{
                width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          display: { sm: 'none' }
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          {/*<Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>*/}
          {/*  Boshqaruv paneli*/}
          {/*</Typography>*/}
          {/*<Box sx={{ display: 'flex', alignItems: 'center' }}>*/}
          {/*  <Typography variant="body1" sx={{ mr: 2, display: { xs: 'none', sm: 'block' } }}>*/}
          {/*    {currentUser?.name || 'Foydalanuvchi'}*/}
          {/*  </Typography>*/}
          {/*  <Tooltip title="Hisob sozlamalari">*/}
          {/*    <IconButton*/}
          {/*      size="large"*/}
          {/*      aria-label="account of current user"*/}
          {/*      aria-controls="menu-appbar"*/}
          {/*      aria-haspopup="true"*/}
          {/*      onClick={handleMenu}*/}
          {/*      color="inherit"*/}
          {/*    >*/}
          {/*      <Avatar sx={{ width: 32, height: 32 }}>*/}
          {/*        <AccountCircleIcon />*/}
          {/*      </Avatar>*/}
          {/*    </IconButton>*/}
          {/*  </Tooltip>*/}
          {/*  <Menu*/}
          {/*    id="menu-appbar"*/}
          {/*    anchorEl={anchorEl}*/}
          {/*    anchorOrigin={{*/}
          {/*      vertical: 'top',*/}
          {/*      horizontal: 'right',*/}
          {/*    }}*/}
          {/*    keepMounted*/}
          {/*    transformOrigin={{*/}
          {/*      vertical: 'top',*/}
          {/*      horizontal: 'right',*/}
          {/*    }}*/}
          {/*    open={Boolean(anchorEl)}*/}
          {/*    onClose={handleClose}*/}
          {/*  >*/}
          {/*    <MenuItem onClick={() => { handleClose(); navigate('/dashboard/profile'); }}>*/}
          {/*      <ListItemIcon>*/}
          {/*        <AccountCircleIcon fontSize="small" />*/}
          {/*      </ListItemIcon>*/}
          {/*      Profil*/}
          {/*    </MenuItem>*/}
          {/*    <Divider />*/}
          {/*    <MenuItem onClick={handleLogout}>*/}
          {/*      <ListItemIcon>*/}
          {/*        <LogoutIcon fontSize="small" />*/}
          {/*      </ListItemIcon>*/}
          {/*      Chiqish*/}
          {/*    </MenuItem>*/}
          {/*  </Menu>*/}
          {/*</Box>*/}
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          mt: { sm: 8, md: 0, lg: 0 },
          // mt: 0, // AppBar height
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Dashboard;
